import { render, staticRenderFns } from "./SliceContactForm.vue?vue&type=template&id=c31ad7ca&lang=pug&"
import script from "./SliceContactForm.vue?vue&type=script&lang=js&"
export * from "./SliceContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports